export default "__VITE_ASSET__B9QUu$it__"